import { IStaffTravel } from '../types/staff-travel.type';

export class StaffTravelHelper {
  /**
   * Make staff key
   *
   * @param travel
   */
  static makeKey(travel: IStaffTravel): string {
    return [travel.school, travel.schoolYear, travel.schoolLevel, travel.groupCode].join('_');
  }
}
